export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-1-cd985529062f7d785059f47d22bbf463.webp";